import React from 'react';
import MediaQuery from 'react-responsive';
// import api from '../../../api-client';
import Button from '../../button/Button';
import { Row, Col } from 'react-flexbox-grid';
import styles from './Call.styl';

class Call extends React.Component {

  handleClick = () => {
    this.props.doneCalling();
  };

  render() {
    return (
      <div className={styles.outerWrapper}>
        <div className={styles.formInnerWrapper}>
          <h3>What should I say?</h3>
          <div className={styles.callBox}>
            <p>
              The Endangered Species Act is among our country’s most important
              tools for saving wildlife from extinction. Nearly every single
              species that has been listed under the ESA has survived, and many
              have recovered. Without the ESA, iconic American species like bald
              eagles, manatees, and alligators would likely be gone forever.
            </p>
            <p>
              That is why I am highly concerned about recent legislative attacks
              on the ESA. Bills have been introduced that would take listing
              decisions away from scientific experts, defund recovery efforts,
              and weaken or eliminate protections for the species that need them
              most.
            </p>
            <p>
              The ESA is a highly effective, flexible, and popular law. Saving
              our nation’s wildlife should not be matter of politics. Please
              tell [Senator or Representative’s name] to support the ESA and
              vote against any attacks on it.
            </p>
            <p>Thank you.</p>
            <p></p>
            <p></p>
            <br />
          </div>
        </div>
        <MediaQuery minDeviceWidth={768}>
          <Row className={styles.buttonRow} center="xs">
            <Col xs={12} sm={4} md={3} className={styles.leftButton}>
              <Button
                title="Done"
                color="#003973"
                setContactType={this.props.setContactType}
                type="thanks"
                doneCalling={this.props.doneCalling}
                clearSelectedMembers={this.props.clearSelectedMembers}
              />
            </Col>
          </Row>
        </MediaQuery>
        <MediaQuery maxDeviceWidth={767}>
          <div className={styles.mobileButton} onClick={this.handleClick}>
            <p>DONE</p>
          </div>
        </MediaQuery>
      </div>
    );
  }
}

export default Call;



// WEBPACK FOOTER //
// ./src/components/forms/call/Call.js